import { Injectable } from '@angular/core';
import { RecallEndPoints } from 'src/app/constants/api-endpoints';
import { Recall } from 'src/app/models/dashboard/recall.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/sections/common/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class RecallService {

  recallUrls = RecallEndPoints;
  isAll = true;

  constructor(private _apiService : ApiService) { }

  private returnResponse(response){
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  getRecallById(id: number): Observable<Recall> {
    return this._apiService.get(this.recallUrls.getRecallById + id, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getRecallList(): Observable<Recall> {
    return this._apiService.get(this.recallUrls.getRecallList, true).pipe(    
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveRecall(recall: Recall): Observable<Recall> {
    return this._apiService.post(this.recallUrls.saveRecall, recall, true, true).pipe(    
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateRecall(id: number, recall: Recall): Observable<Recall> {
    return this._apiService.put(this.recallUrls.updateRecall + id, recall, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  deleteRecall(id: number): Observable<Recall> {
    return this._apiService.delete(this.recallUrls.deleteRecall, id.toString(), true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getRecallListByUser(id: number): Observable<Recall> {
    let url = this.recallUrls.getRecallListByUser
    url = url.replace('{userId}', id.toString())
    return this._apiService.get(url, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

}
